import { useState } from 'react';
import { SchemaContextType, SchemaViewerContext } from './SchemaContext';
import { FormContextType, RJSFSchema } from '@rjsf/utils';
import { SchemaRegistry } from './definitions/schemaRegistry';

export const SchemaProvider = ({ children }: { children: React.ReactNode }) => {
  const [schema, setSchema] = useState<RJSFSchema | null>(null);
  const [selectedRegistry, setSelectedRegistry] = useState<SchemaRegistry | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [formData, setFormData] = useState<FormContextType | null>({});

  const contextValue: SchemaContextType = {
    schema,
    setSchema,
    selectedRegistry,
    setSelectedRegistry,
    error,
    setError,
    formData,
    setFormData,
  };

  return (
    <SchemaViewerContext.Provider value={contextValue}>
      {children}
    </SchemaViewerContext.Provider>
  );
};